import React, { Component } from "react";
import { Container, Row, Col, Image, Form, Button, Modal, Nav, Spinner, ButtonGroup, Tab, Dropdown } from "react-bootstrap";

import swal from 'sweetalert';
import C from '../lib/Config';
import Side from "./Sidebar";
import Top from "./Topbar";

import {Pagination, PaginationOpts, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
const CustomTable = React.memo(props => {
    const {
          data, rowsPerPageOption, tableHeaders, onChangeFilter, onPageNavigate, classes, onRowsPerPageChange, onSortChange,
          tableClass, labels, filterable, filterText, rowsPerPage, currentPage, sortedProp, maxPage, Components
    } = useDatatableLifecycle(props);
  
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search...'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
  }, shouldTableUpdate);
export default class Appointments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            allAppointmentData: [], isHospitalStaff: false
        }
    }
    componentDidMount() {  this.getAllAppointmentData(); }
    
    formatDateMMDDYY(date) {
      if (date !== undefined && date !== "") {
          const d = new Date(date);
          const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          const timeStr = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
          return `${dateStr} ${timeStr}`;
      }
      return "";
    }

    getAllAppointmentData() {
        var userId = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
        let url;
        if (roleIdFromCache === 3) {
            this.setState({ isHospitalStaff: true });
            url = C.getUrl() + '/login/getAllAppointmentDataForHospitalStaff/' + userId;
        }else {
            url = C.getUrl() + '/login/getAllAppointmentData/' + userId;
        }

        return fetch(url)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                //alert(error);
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                let obj = resObj.message;
                if (obj === 'No record found.') {
                
                } else {
                    //console.log(obj);
                    let tempData = typeof resObj.message === 'string' ? JSON.parse(resObj.message) : resObj.message;
                    let allAppointmentData = [];
                    if (Array.isArray(tempData)) {
                        tempData.forEach(obj => {
                        let data = {
                            name : obj.firstName +' '+ obj.lastName,
                            caseID : obj.caseId,
                            genderName : obj.genderMstDto.genderName,
                            phoneNumber : obj.phoneNumber1,
                            instituteName : obj.instituteDto.instituteName,
                            chemoDate : this.formatDateMMDDYY(obj.chemoDate),
                            doctorName : (obj.doctor !== undefined) ? obj.doctor.firstName +' '+ obj.doctor.lastName : ''
                        }
                        allAppointmentData.push(data);
                    });
                    }
                    //console.log(allAppointmentData);
                    this.setState({ allAppointmentData: allAppointmentData });
                    //console.log(this.state.allAppointmentData);
                }
            }
        })
        .catch(err => {
            //console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }
    
    render() {
        const { isHospitalStaff } = this.state;
        let header;
        if (isHospitalStaff) {
          header = [{title: 'Full Name', prop: 'name', sortable: true, filterable: true},{title: 'Chemo Date', prop: 'chemoDate', sortable: true, filterable: true},{title: 'Case Id', prop: 'caseID', sortable: true, filterable: true},{title: 'Gender Name', prop: 'genderName', sortable: true, filterable: true},{title: 'Phone No', prop: 'phoneNumber', sortable: true, filterable: true},{title: 'Institute Name', prop: 'instituteName', sortable: true, filterable: true},{title: 'Doctor Name', prop: 'doctorName', sortable: true, filterable: true},];
        }else {
          header = [{title: 'Full Name', prop: 'name', sortable: true, filterable: true},{title: 'Chemo Date', prop: 'chemoDate', sortable: true, filterable: true},{title: 'Case Id', prop: 'caseID', sortable: true, filterable: true},{title: 'Gender Name', prop: 'genderName', sortable: true, filterable: true},{title: 'Phone No', prop: 'phoneNumber', sortable: true, filterable: true},{title: 'Institute Name', prop: 'instituteName', sortable: true, filterable: true},];
        }
        
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found', placeholder: 'Search'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light',};
       
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <Row>
                                        <Col lg='12'>
                                            <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                <div className="card-header flex-wrap pb-0">
                                                    <h3 className="fs-18 header_title mb-0 text-black">Appointments</h3>
                                                </div>
                                                <div className="card-body p-3">
                                                    <Row>
                                                        <Col lg='12'>
                                                            <CustomTable
                                                                id="datatableProtocolList"
                                                                tableHeaders={header}
                                                                tableBody={this.state.allAppointmentData} 
                                                                rowsPerPage={8}
                                                                //rowsPerPageOption={[5, 10, 15, 20]}
                                                                initialSort={{ prop: 'chemoDate', isAscending: true }}
                                                                labels={customLabels}
                                                                classes={classes}
                                                                filter={ { type: 'TextFilter', delay: 1000, placeholder: 'something here' } }
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}